import React, { useState, useEffect, useMemo } from "react";
import TablePendingTransfer from "../components/TablePendingTransfer";
import api from "../globals/axios";
import { HOME_PAGE, SERVER_BASE_ADDRESS } from "../globals/const";
import { useNavigate } from "react-router-dom";
import CustomAppBar from "../components/AppBar";
import { Container } from "@mui/material";
import { getRoleFromLocal } from "../globals/authentication";

export default function PendingTransfers() {
  const [pendingTransfers, setPendingTransfers] = useState([]);
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        Header: "Token Sender",
        accessor: "initiator_email",
      },
      {
        Header: "Token Code",
        accessor: "parent_token_code",
      },
      {
        Header: "Amount of Token",
        accessor: "transfer_amount",
      },
      {
        Header: "Claim",
        accessor: "claim",
        Cell: ({ row }) => (
          <button
            style={{
              border: "none",
              background: "none",
              color: "#1976d2",
              fontSize: "1rem",
              marginLeft: "10px",
              cursor: "pointer",
            }}
            onClick={() => handleClaim(row)}
          >
            Claim
          </button>
        ),
      },
    ],
    []
  );

  useEffect(() => {
    const setData = async () => {
      const res = await api.get(
        `${SERVER_BASE_ADDRESS}/chain/pending-transfers`
      );
      setPendingTransfers(res.data.pending_transfers);
    };
    setData();
  }, []);

  const handleClaim = (row) => {
    const tokenCode = row.original.parent_token_code;
    const roleInfo = getRoleFromLocal();

    if (roleInfo === "TRANSPORTER") {
      window.open(HOME_PAGE + `/transport/${tokenCode}`);
    } else if (roleInfo === "FARMER") {
      navigate("/create-farmland?tokenCode=" + tokenCode);
    } else if (roleInfo === "PROCESSOR") {
      window.open(HOME_PAGE + `/create-batch?tokenCode=${tokenCode}`);
    } else if (roleInfo === "STORAGE") {
      window.open(HOME_PAGE + `/create-storage?tokenCode=${tokenCode}`);
    }
  };

  return (
    <div>
      <CustomAppBar />
      <Container style={{ paddingTop: "4rem" }}>
        <TablePendingTransfer columns={columns} data={pendingTransfers} />
      </Container>
    </div>
  );
}
